











import {ChartDataTemplate, FusionDisplayConfTpl, WConfTpl, WidgetDefinition, WParamTpl} from "@/components/widgets/WidgetFather"
import {datePeriodStartDate, getTodayYYYYMMDD, toYYYYMMDD} from "@/data/sources/dates"
import {bus} from "@/main"
import {defineComponent, reactive} from "@vue/composition-api"
import FusionChartWidget from "@/components/widgets/FusionChartWidget.vue"
import {executeQuery} from "@/data/repos/query"

export function config(): WidgetDefinition {
    return {
      ...WConfTpl.Custom(),
      widget: "AuditFailureByResponsibilityGroup",
      title: "Failure by responsibility group",
      cType: "column2d",
      params: {
        auditCategory: {...WParamTpl.auditCategory(), _order: 1},
      },
      fusionChartParams: {
        numberFormatting: {...FusionDisplayConfTpl.numberFormatting()},
      },
    }
  }

  function getChartDataConfig() {
    return reactive({
        ...ChartDataTemplate(),
        xAxisName: "Responsibility group",
        yAxisName: "No. of failures",
        rotateLabels: "1",
        slantLabels: "1",
        showLabels: "1",
        showValues: "1",
        usePlotGradientColor: "0",
        canvasTopPadding: "12",
      },
    )
  }

  async function configChangeCallback(config: any, chartConfig: any, chartDataConfig: any) {
    if (config) {
      chartDataConfig.subCaption = "Category: " + (config.params.auditCategory.value.title || "<All>")
    }
  }

  export default defineComponent({
    props: {
      config: {type: Object, required: true},
    },
    components: {
      FusionChartWidget,
    },
    setup(props, context) {
      const fromDate = toYYYYMMDD(datePeriodStartDate(new Date(), "1y"))
      const toDate = getTodayYYYYMMDD()

      context.emit("config-update", config())

      let lastData: any[]

      async function dataFetcher(params: any) {
        const fromDate = toYYYYMMDD(datePeriodStartDate(new Date(), "1y"))
        const toDate = getTodayYYYYMMDD()
        const categoryID = params.auditCategory.value.value || 0
        const auditStatus = 3
        lastData = await executeQuery("micad4-audit", "failureByResponsibilityGroup",
          {locale: "en-GB", fromDate, toDate, categoryID, auditStatus},
          dataFilter)
        return {
          data: lastData,
        }
      }

      function dataplotClickCallback(label: string, val: any, data: any) {
        //ToDo: drill down datasource needs to take parameters as well
        if (!val) {
          return
        }
        console.debug("label:", label)
        console.debug("val:", val)
        console.debug("data:", data)
        console.debug("lastData:", lastData)
        const responsibilityGroupId = lastData[data.dataIndex].additionalValue
        bus.$emit("chartPopup", {
          title: "Failure by responsibility group (" + label + ", " + val + ")",
          component: () => import("@/components/widgets/audit/AuditFailureByResponsibilityGroupDrillDown.vue"),
          componentArgs: {
            fromDate: fromDate,
            toDate: toDate,
            responsibilityGroupId: responsibilityGroupId,
            categoryId: props.config.params.auditCategory.value.value || 0,
            auditStatus: 3,
          },
        })
      }

      return {dataFetcher, getChartDataConfig, dataplotClickCallback, configChangeCallback}
    },
  })

  function dataFilter(
    data: { name: string, responsibilityGroupID: number, outstandingActionCount: number, completed: number, colour: string }[]): any[] {
    return data.map((v) => {
        return {
          label: v.name,
          value: v.outstandingActionCount + v.completed,
          additionalValue: v.responsibilityGroupID,
          color: v.colour
        }
      },
    )
  }
